import React from 'react';
import { Button } from '../ui/button';
import { ZoomIn, ZoomOut, ChevronLeft, ChevronRight } from 'lucide-react';

const PDFFooter = ({
  pageNumber, numPages, goToPage, navegarAPagina,
  scale, handleZoomIn, handleZoomOut,
  isSuperAdmin, isAdmin, canPrint, maxPrintPages
}) => {
  // Si el padre nos pasó navegarAPagina (helper unificado que maneja modo continuo),
  // lo usamos. Caso contrario caemos a goToPage (compatibilidad).
  const navegar = navegarAPagina || goToPage;
  return (
    <div className="flex items-center justify-between px-4 py-2 bg-slate-800 border-t border-slate-700 flex-shrink-0">
      {/* Navegacion movil */}
      <div className="flex items-center gap-2 md:hidden">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => navegar(pageNumber - 1)} 
          disabled={pageNumber <= 1}
          className="h-10 w-10 p-0 text-slate-300"
        >
          <ChevronLeft className="h-5 w-5" />
        </Button>
        <span className="text-white text-sm">
          {pageNumber} / {numPages}
        </span>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => navegar(pageNumber + 1)} 
          disabled={pageNumber >= numPages}
          className="h-10 w-10 p-0 text-slate-300"
        >
          <ChevronRight className="h-5 w-5" />
        </Button>
      </div>

      {/* Info de restricciones — oculto en mobile para no amontonar el contador de páginas;
          la info igualmente aparece en el diálogo de Imprimir cuando el usuario va a imprimir. */}
      <div className="flex-1 text-center hidden md:block">
        <p className="text-xs text-slate-500">
          {isSuperAdmin ? (
            <span className="text-amber-400">Super Administrador - Descarga habilitada</span>
          ) : isAdmin ? (
            <span className="text-cyan-400">Administrador - Solo visualizacion</span>
          ) : canPrint ? (
            <span>Impresion permitida (max. {maxPrintPages} paginas con marca de agua)</span>
          ) : (
            <span>Documento protegido - Solo visualizacion</span>
          )}
        </p>
      </div>

      {/* Zoom movil */}
      <div className="flex items-center gap-1 md:hidden">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={handleZoomOut}
          data-testid="footer-zoom-out"
          className="h-11 w-11 p-0 text-slate-300 active:bg-teal-500/30 border border-slate-600"
        >
          <ZoomOut className="h-5 w-5" />
        </Button>
        <span className="text-slate-400 text-xs font-mono min-w-[3rem] text-center">{Math.round(scale * 100)}%</span>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={handleZoomIn}
          data-testid="footer-zoom-in"
          className="h-11 w-11 p-0 text-slate-300 active:bg-teal-500/30 border border-slate-600"
        >
          <ZoomIn className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
};

export default PDFFooter;
